import { render, staticRenderFns } from "./BlogCoverPreview.vue?vue&type=template&id=8fb817fc&scoped=true&"
import script from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
export * from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
import style0 from "./BlogCoverPreview.vue?vue&type=style&index=0&id=8fb817fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb817fc",
  null
  
)

export default component.exports